module.exports = __webpack_public_path__ + "img/4.35ffe615.jpg";